import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import * as Icons from "lucide-react";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    api.get("/catalog/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="page-categories">
      <PageHeader eyebrow="Browse" title="Categories" subtitle="Explore cashback across every part of life." />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
        {cats.map((c) => {
          const Icon = Icons[c.icon] || Icons.Sparkles;
          return (
            <Link
              key={c.slug}
              to={`/app/categories/${c.slug}`}
              data-testid={`cat-${c.slug}`}
              className="border border-gray-200 rounded-2xl p-6 bg-white text-center hover:-translate-y-0.5 hover:shadow-card transition-all"
            >
              <div className="mx-auto w-12 h-12 rounded-xl bg-emerald-50 text-emerald-700 flex items-center justify-center mb-3 border border-emerald-100">
                <Icon className="w-6 h-6" />
              </div>
              <div className="font-display font-semibold text-gray-900">{c.name}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
